module.exports = __webpack_public_path__ + "media/application/images/placeholder-f751fbb9700044263ad88508de03eb05.jpg";